import { render, staticRenderFns } from "./AddNewGprs.vue?vue&type=template&id=0497c4a4&"
import script from "./AddNewGprs.vue?vue&type=script&lang=js&"
export * from "./AddNewGprs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports